<template>
  <!-- BEGIN: Modal Content -->
  <Dialog staticBackdrop :open="modalOpened" @close="hideModal()">
    <Dialog.Panel>
      <Dialog.Description style="height: 40vh;">
      <div class="overflow-auto h-full p-5 text-center">
        <Lucide
          v-if="props.type == 'Success!'"
          icon="CheckCircle"
          class="w-16 h-16 mx-auto mt-3 text-success"
        />
        <Lucide
          v-else
          icon="XCircle"
          class="w-16 h-16 mx-auto mt-3 text-warning"
        />
        <div class="mt-5 text-3xl">{{ props.type }}</div>
        <div v-if="props.type !='Delete?'" class="mt-2 text-slate-500">{{ props.message }}</div>
        <div v-else class="mt-2 text-slate-500">
          <input id="checkConsent" class="mr-2" type="checkbox" />{{ props.message }}</div>
          <div v-if="props.type !='Delete?'" class="px-5 pb-8 text-center">
        <Button
          type="button"
          variant="primary"
          @click="hideModal()"
          class="w-24 mt-10"
        >
          Ok
        </Button>
      </div>
      <div class="flex justify-between px-5 pb-8 text-center" v-else>
         <Button
          type="button"
          variant="primary"
          @click="deleteAction()"
          class="w-24 mt-10"
        >
          Delete
        </Button>
        <Button
          type="button"
          variant="secondary"
          @click="hideModal()"
          class="w-24 mt-10"
        >
          Cancel
        </Button>
      </div>
      </div>
      </Dialog.Description>
    </Dialog.Panel>
  </Dialog>
  <!-- END: Modal Content -->
</template>

<script setup>
import { ref } from "vue";
import { Dialog } from "@/base-components/Headless";
import Button from "@/base-components/Button";
import Lucide from "@/base-components/Lucide";
import { useRouter, useRoute } from "vue-router";
const props = defineProps({
  message: String,
  type: String,
});
const emit = defineEmits(["close"]);
const modalOpened = ref(true);
const router = useRouter();
const route = useRoute();

const hideModal = () => {
  modalOpened.value = false;
  emit("close");
};
function deleteAction() {
  const consent = document.getElementById("checkConsent").checked;
  if(consent) {
  const targetOrigin = window.location.origin;
  window.postMessage("accountDeleted", targetOrigin);
  hideModal();
  }
}
</script>
